/**
 * Public error code the compose-message endpoint returns when a draft changes a template
 * placeholder. Shared here so the browser can recognise it without importing the Node error map.
 */
export const COMPOSE_MESSAGE_PLACEHOLDER_MISMATCH_CODE = 'prompt-bridge-064';
